import { useState } from 'react';

import { UploadContext } from '../../shared/contexts/uploadContext';
import type { UploadState, UploadProviderProps } from '../../shared/types/UploadType';

export const UploadProvider: React.FC<UploadProviderProps> = ({ children }) => {
  const [uploadState, setUploadState] = useState<UploadState>({
    isUploading: false,
    uploadProgress: {},
    uploadResults: [],
    currentFileIndex: 0,
    totalFilesCount: 0,
    uploadController: null
  });

  const updateUploadState = (updates: Partial<UploadState> | ((prev: UploadState) => Partial<UploadState>)) => {
    if (typeof updates === 'function') {
      setUploadState(prev => ({ ...prev, ...updates(prev) }));
    } else {
      setUploadState(prev => ({ ...prev, ...updates }));
    }
  };

  const resetUploadState = () => {
    setUploadState({
      isUploading: false,
      uploadProgress: {},
      uploadResults: [],
      currentFileIndex: 0,
      totalFilesCount: 0,
      uploadController: null
    });
  };

  return (
    <UploadContext.Provider value={{ uploadState, updateUploadState, resetUploadState }}>
      {children}
    </UploadContext.Provider>
  );
};